module.exports = __webpack_public_path__ + "img/sawtooth-bottom.17ba31a2.png";